import * as React from 'react';
import { MenuItem, Menu, ListItemText, ListItemIcon } from '@mui/material';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

const MultiLevelMenuItem = ({ label, children, icon: IconComponent }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const closeTimeoutRef = React.useRef(null);
    const isOverSubmenu = React.useRef(false);

    const handleMouseEnter = (event) => {
        // Clear any pending close
        if (closeTimeoutRef.current) {
            clearTimeout(closeTimeoutRef.current);
            closeTimeoutRef.current = null;
        }
        setAnchorEl(event.currentTarget);
    };

    const handleMouseLeave = () => {
        // Delay closing to give time to move to submenu
        closeTimeoutRef.current = setTimeout(() => {
            // Only close if not hovering over submenu
            if (!isOverSubmenu.current) {
                setAnchorEl(null);
            }
        }, 200);
    };

    const handleSubmenuEnter = () => {
        isOverSubmenu.current = true;
        // Clear any pending close
        if (closeTimeoutRef.current) {
            clearTimeout(closeTimeoutRef.current);
            closeTimeoutRef.current = null;
        }
    };

    const handleSubmenuLeave = () => {
        isOverSubmenu.current = false;
        // Close when leaving submenu
        setAnchorEl(null);
    };

    React.useEffect(() => {
        return () => {
            if (closeTimeoutRef.current) {
                clearTimeout(closeTimeoutRef.current);
            }
        };
    }, []);

    return (
        <React.Fragment>
            <MenuItem 
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                sx={{ 
                    display: 'flex', 
                    justifyContent: 'space-between',
                    minWidth: '200px',
                    // Highlight parent saat submenu terbuka
                    backgroundColor: Boolean(anchorEl) ? 'action.selected' : 'transparent',
                    '&:hover': {
                        backgroundColor: Boolean(anchorEl) ? 'action.selected' : 'action.hover',
                    },
                }}
            >
                {IconComponent && <ListItemIcon>{IconComponent}</ListItemIcon>}
                <ListItemText>{label}</ListItemText>
                <KeyboardArrowRightIcon sx={{ fontSize: 16 }} />
            </MenuItem>

            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                disableAutoFocus
                disableEnforceFocus
                disableRestoreFocus
                disableScrollLock
                BackdropProps={{
                    invisible: true,
                    sx: { pointerEvents: 'none' }
                }}
                PaperProps={{
                    onMouseEnter: handleSubmenuEnter,
                    onMouseLeave: handleSubmenuLeave,
                    sx: {
                        marginLeft: '4px',
                        pointerEvents: 'auto',
                    }
                }}
                sx={{
                    pointerEvents: 'none',
                }}
                slotProps={{
                    root: {
                        sx: { pointerEvents: 'none' }
                    }
                }}
            >
                {children}
            </Menu>
        </React.Fragment>
    );
};

export default MultiLevelMenuItem;